export default "__VITE_ASSET__BkQkLnR1__"